const MAX_QTY_ALLOWED = 5;
export default MAX_QTY_ALLOWED;



// WEBPACK FOOTER //
// ./src/constants/myBag.js